import { useState } from "react";

export const useMapState = <K, V>(
  initialEntries?: Iterable<readonly [K, V]>
) => {
  const [map, setMap] = useState<ReadonlyMap<K, V>>(
    () => new Map(initialEntries)
  );
  const set = (key: K, value: V) => {
    setMap((prev) => {
      const newMap = new Map(prev);
      newMap.set(key, value);
      return newMap;
    });
  };
  const deleteKey = (key: K) => {
    setMap((prev) => {
      const newMap = new Map(prev);
      newMap.delete(key);
      return newMap;
    });
  };
  const reset = (entries?: Iterable<readonly [K, V]>) => {
    setMap(() => new Map(entries));
  };
  return { value: map, set, delete: deleteKey, reset };
};
